import { CurrencyPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { OrderLimitStopOrUndefinedPipe, OrderStopLimitPipe } from '@zero/shared/ui-pipes';
import { OrderData } from '@zero/shared/util-models';
import { defaultQuoteFormat } from 'constants/shared-constants';

@Component({
  selector: 'order-zero-stop-limit-data',
  templateUrl: './stop-limit-data.component.html',
  imports: [CurrencyPipe, OrderLimitStopOrUndefinedPipe, OrderStopLimitPipe],
})
export class StopLimitDataComponent {
  @Input() public order: OrderData;

  public readonly quoteFormat = defaultQuoteFormat;
}
